import Vue from "vue";
import store from "@/store";
import config from "@/config";
import Repository from "@/repositories/https";
import { toReauth, verifyJTI } from "@core/config/utils";

export const isLoggedIn = (to, from, next) => {
  const keycloak = Vue.prototype.$keycloak;
  const loggedIn = keycloak.authenticated;

  if (
    window.location.port != "8080" &&
    to.matched.some((record) => record.meta.requiresAuth) &&
    !loggedIn
  ) {
    return;
  }

  if (to.params.accountId) {
    /*** adding accountId in API end point */
    let accountId = to.params.accountId;
    store.commit("auth/account.id", accountId);
    Repository.defaults.baseURL = `${config.API_BASE_URL}/${accountId}`;
  }
  
  next();
};

export const devIdentiyTokenHandler = (to, from, next) => {
  let accountId = 20001;
  if (window.location.port == "8080") {
    if (to.path == "/" && Vue.prototype.$keycloak && Vue.prototype.$keycloak.token) {
      next(`/${accountId}/dashboard`);
    }
  }
  next();
};

export const pageLoadHandler = (to) => {
  let mainTitle = "Maropost Service Cloud";
  /**
   * Generate document title based on the name, getting here from the defined route.
   */
  let title = mainTitle;
  if (to.name) {
    const nameToArr = to.name.replace(/-/g, " ").split(" ");
    for (var i = 0; i < nameToArr.length; i++) {
      nameToArr[i] =
        nameToArr[i].charAt(0).toUpperCase() + nameToArr[i].slice(1);
    }
    const modifiedName = nameToArr.join(" ");
    title = mainTitle + " - " + modifiedName;
  }
  if (["Auth", "Dashboard"].includes(to.meta.layout)) {
    store.commit("ui/layout", to.meta.layout);
  } else {
    store.commit("ui/layout", "Dashboard");
  }
  document.title = title;
};

/** router does not exist. redirecting to 404 page */
export const pageNotFound = (to, from, next) => {
  if (!to.matched.length) {
    next("/404");
  } else {
    next();
  }
};
